@use '@/styles/mastodon/mixins';

.root {
  --col-gap: var(--space-xs);
  --avatar-size: 40px;
  --content-col: 2;

  display: grid;
  grid-template-columns: calc(var(--avatar-size) + var(--col-gap)) auto;
  grid-template-rows: minmax(calc(var(--avatar-size) + var(--col-gap)), auto);
  grid-auto-rows: auto;
  row-gap: var(--space-xs);
  padding: var(--space-md);
}

.variantThread {
  --avatar-size: 32px;

  padding: var(--space-xs) 0;
}

.variantPage {
  padding: 0;
}

.isQuote {
  padding: var(--space-sm);
}

.variantPage,
.isQuote {
  --content-col: span 2;
}

.header {
  grid-column: span 2;
}

.content,
.footer,
.root :global(.status__prepend),
.root :global(.content-warning),
.translate {
  grid-column: var(--content-col);
}

.translate {
  display: flex;
  align-items: center;
}

.translateInfo {
  @include mixins.type-label-md;

  color: var(--color-text-secondary);
  margin-inline-start: auto;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);

  &.collapsed {
    position: relative;
    max-height: 15lh;
    overflow-y: clip;

    &::after {
      content: '';
      position: absolute;
      inset-inline: 0;
      inset-block-end: 0;
      height: calc(var(--space-4xl) * 2);
      background: linear-gradient(
        to bottom,
        transparent,
        var(--color-bg-blend)
      );
      pointer-events: none;
    }
  }
}

.contentText {
  @include mixins.type-body;

  p:not(:last-child) {
    margin-block-end: 1em;
  }

  a {
    color: var(--color-text-brand);
  }
}

.contentImage {
  border-radius: var(--radius-md);
  position: relative;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

.contentBlurHash {
  width: 100%;
  height: 100%;
}

.contentReadMore {
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  z-index: 1;
}

.footer {
  overflow: hidden;
}

.hashtagsWrapper,
.hashtags {
  display: flex;
  gap: var(--space-2xs);
  flex-wrap: nowrap;
}

.hashtagsWrapper {
  padding: var(--space-2xs) 0;
}

.hashtags {
  overflow: hidden;
  position: relative;

  > button {
    flex-shrink: 0;
  }
}

.hashtagsShowAll {
  flex-wrap: wrap;
  overflow: visible;
  max-width: none !important;
}

.meta {
  @include mixins.type-micro;

  color: var(--color-text-secondary);
}

.actions {
  display: flex;

  > button:not(:hover, :active, [aria-pressed='true'], [aria-expanded='true']) {
    opacity: 0.7;
  }
}

.actionsButtonGap {
  margin-inline-end: auto;
}
